<template>
  <div class="w-full headerSize border-b bg-gray-100 dark:bg-dark-400 dark:border-dark-200">
    <div class="h-full text-center flex px-4">
      <button
        v-for="course in courseList"
        :key="course.serial"
        class="px-8 my-2 mx-1 rounded cursor-pointer focus:outline-none"
        :class="{
          'bg-gray-200 dark:bg-dark-10 text-arena-lighter':
            course.serial == dashboardModalStatePresenter.courseSerial.value
        }"
        @click="click(course.id, course.serial)"
      >
        <div class="text-xl">
          {{ course.shortName }}
        </div>
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useDashboardModalStatePresenter } from '@/presentation/composables/dashboard/useDashboardModalStatePresenter'
import { useCoursePresenter } from '@/presentation/composables/problem/useCoursePresenter'

export default defineComponent({
  setup(props, ctx) {
    const dashboardModalStatePresenter = useDashboardModalStatePresenter()
    const coursePresenter = useCoursePresenter()
    const { displayLanguage } = useConfigStatePresenter()

    const courseList = computed(() =>
      Object.values(coursePresenter.courseList.value)
        .sort((a, b) => a.serial - b.serial)
        .map(course => ({ ...course, serial: course.serial - 1 }))
    )

    const click = async (id: number, serial: number) => {
      dashboardModalStatePresenter.setCourseSerial(serial)
      // await coursePresenter.getCourseById(displayLanguage.value, id)
    }

    return {
      dashboardModalStatePresenter,
      click,
      courseList
    }
  }
})
</script>
<style lang="postcss" scoped>
.headerSize {
  height: 50px;
}
.image-style {
  @apply text-aoj;
  font-size: 40px;
  width: 40px;
  height: 40px;
}
.image-style-dark {
  @apply text-dark-100;
  font-size: 40px;
  width: 40px;
  height: 40px;
}
.primary {
  @apply bg-aoj border-2 border-aoj text-white;

  &:active {
    @apply bg-aoj-click;
  }
  &:focus {
    @apply outline-none;
  }
}

.primary-dark {
  @apply bg-dark border border-dark-100 text-dark-text;

  &:active {
    @apply bg-dark-100 border-dark-10;
  }
  &:focus {
    @apply outline-none;
  }
}
</style>
